<template>
  <v-card outlined>
    <v-card-title class="text-subtitle-2 grey lighten-4 text-break">
      <v-icon>mdi-calendar-month</v-icon> Date Specifications
    </v-card-title>
    <v-card-text>
      <v-col cols="12" sm="12">
        <v-row
          v-for="header in headersParametersDateSpecifications"
          :key="header.value"
          no-gutters
        >
          <v-col v-if="header.type === 'text'" cols="header.cols">
            <v-text-field
              dense
              :label="header.text"
              clearable
              v-model="search[header.value]"
              hide-details="auto"
              outlined
              @change="emitSearch"
            ></v-text-field>
          </v-col>
          <v-col v-else-if="header.type === 'label'" cols="header.cols">
            <label hide-details="auto"> {{ header.text }} </label>
          </v-col>
          <v-col v-else-if="header.type === 'emptyLine'" cols="header.cols">
            <br />
          </v-col>
          <v-col v-else-if="header.type === 'date'" cols="header.cols">
            <date-picker
              :label="header.text"
              v-model="dateIso[header.value]"
              @input="onDatePickerInput(header.value)"
              :openOnClick="true"
              :min="dateIso[header.min]"
            ></date-picker>
          </v-col>
        </v-row>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
import { parseToDateString } from '@/services/DatetimeUtils.js';

export default {
  components: {
    DatePicker: () => import('@/components/common/DatePicker.vue')
  },
  props: {
    searchPassed: {
      typeof: Array,
      required: true,
      default: []
    },
  },
  data() {
    return {
      headersParametersDateSpecifications: [
        {
          text: "Issue Date",
          value: "issueDate",
          type: "label",
          cols: "12",
          class: "text-subtitle-1 font-weight-bold",
        },
        {
          text: "From",
          value: "issueDateFrom",
          min: "",
          max: "issueDateTo",
          type: "date",
          cols: "12",
          class: "text-subtitle-1 font-weight-bold",
        },
        {
          text: "To",
          value: "issueDateTo",
          min: "issueDateFrom",
          max: "",
          type: "date",
          cols: "12",
          class: "text-subtitle-1 font-weight-bold",
        },
        {
          text: "",
          value: "emptyLineIssueDateFrom",
          type: "emptyLine",
          cols: "12",
          class: "text-subtitle-1 font-weight-bold",
        },
        {
          text: "Service Limit Time",
          value: "serviceLimitTime",
          type: "label",
          cols: "12",
          class: "text-subtitle-1 font-weight-bold",
        },
        {
          text: "From",
          value: "serviceLimitTimeFrom",
          min: "",
          max: "serviceLimitTimeTo",
          type: "date",
          cols: "12",
          class: "text-subtitle-1 font-weight-bold",
        },
        {
          text: "To",
          value: "serviceLimitTimeTo",
          min: "serviceLimitTimeFrom",
          max: "",
          type: "date",
          cols: "12",
          class: "text-subtitle-1 font-weight-bold",
        },
        {
          text: "",
          value: "emptyLineServiceLimitTime",
          type: "emptyLine",
          cols: "12",
          class: "text-subtitle-1 font-weight-bold",
        },
        {
          text: "Service Period >=",
          value: "servicePeriod",
          type: "text",
          cols: "12",
          class: "text-subtitle-1 font-weight-bold",
        },
      ],
      dateMenus: [
        { issueDateFrom: false },
        { issueDateTo: false },
        { serviceLimitTimeFrom: false },
        { serviceLimitTimeTo: false },
      ],
      dateIso: [
        { issueDateFrom: null },
        { issueDateTo: null },
        { serviceLimitTimeFrom: null },
        { serviceLimitTimeTo: null },
      ],
      search: this.searchPassed,
    };
  },
  computed: {},
  methods: {
    emitSearch(){
      // console.log(this.search)
      this.$emit("searchDates", this.search)
    },

    onDatePickerInput(field) {
      var value = this.dateIso[field]
      var dateString = value ? parseToDateString(value) : null;
      this.search[field] = dateString; 
      this.emitSearch();
    }
  },
};
</script>